import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';
import { useEventListener } from '@grandvisionhq/utils';

const ScrollUpButton = ({ showPosition =400 , stopPosition =0  })=>{
    const { getLabel  } = useIntl();
    const [show, setShow] = React.useState(false);
    React.useEffect(()=>{
        toggleScrollTopButton();
    }, []);
    const handleClick = React.useCallback(()=>{
        window.scrollTo(0, stopPosition);
    }, [
        stopPosition
    ]);
    const toggleScrollTopButton = React.useCallback(()=>{
        setShow(showPosition < window.scrollY);
    }, [
        showPosition
    ]);
    useEventListener('scroll', toggleScrollTopButton);
    const classNames = classnames('scroll-to-top', {
        'scroll-to-top--show': show
    });
    return /*#__PURE__*/ React.createElement("button", {
        "aria-label": getLabel('common.scrollUp'),
        className: classNames,
        onClick: handleClick
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "chevron-up"
    }));
};

export { ScrollUpButton as default };
//# sourceMappingURL=ScrollUpButton.js.map
